// extracted by mini-css-extract-plugin
export default {"module_view":"styles_module_view__sOMOF","module_view_header":"styles_module_view_header__47H9s","module_view_content":"styles_module_view_content__vTIFw"};